module.exports = __webpack_public_path__ + "img/T1A_rc_23.cf6f7e47.png";